import * as Cesium from 'cesium';
export const STORAGE_KEY = 'landscope_unsaved_polygons';
export const serializePolygonsForStorage = (polygons, projectId, existingJson) => {
    let existingItems = [];
    if (existingJson) {
        try {
            existingItems = JSON.parse(existingJson);
        }
        catch ( /* ignore */_a) { /* ignore */ }
    }
    const otherProjectItems = existingItems.filter(item => item.projectId !== projectId);
    const currentProjectItems = [];
    polygons.forEach((p) => {
        const vertices = p.vertices.map(v => {
            const cart = Cesium.Cartographic.fromCartesian(v.position);
            return {
                lat: Cesium.Math.toDegrees(cart.latitude),
                lng: Cesium.Math.toDegrees(cart.longitude)
            };
        });
        currentProjectItems.push({
            id: p.id,
            name: p.name,
            vertices,
            color: p.color,
            outlineColor: p.outlineColor,
            displayUnit: p.displayUnit,
            lengthUnit: p.lengthUnit,
            projectId: p.projectId,
            fillOpacity: p.fillOpacity,
            showMeasurements: p.showMeasurements
        });
    });
    return [...otherProjectItems, ...currentProjectItems];
};
export const deserializeStoredPolygons = (stored, projectId) => {
    return stored
        .filter(s => s.projectId === projectId)
        .map(s => ({
        id: s.id,
        name: s.name,
        color: s.color,
        outlineColor: s.outlineColor,
        unit: s.displayUnit,
        lengthUnit: s.lengthUnit,
        vertices: s.vertices.map(v => ({ latitude: v.lat, longitude: v.lng })),
        projectId: s.projectId,
        fillOpacity: s.fillOpacity,
        showMeasurements: s.showMeasurements
    }));
};
